import { useEffect } from "react";
import { useContent } from "./theme";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export function SeoMeta() {
  const seo = useContent("seo");
  useEffect(() => {
    if (seo.title) {
      document.title = seo.title;
      setMeta("property", "og:title", seo.title);
      setMeta("name", "twitter:title", seo.title);
    }
    if (seo.description) {
      setMeta("name", "description", seo.description);
      setMeta("property", "og:description", seo.description);
      setMeta("name", "twitter:description", seo.description);
    }
    if (seo.image) {
      const abs = /^https?:/.test(seo.image) ? seo.image : `${window.location.origin}${seo.image.startsWith("/") ? "" : "/"}${seo.image}`;
      setMeta("property", "og:image", abs);
      setMeta("property", "og:image:secure_url", abs);
      setMeta("name", "twitter:image", abs);
      if (!/og-card\.jpg$/.test(abs)) {
        document.head.querySelector('meta[property="og:image:width"]')?.remove();
        document.head.querySelector('meta[property="og:image:height"]')?.remove();
        document.head.querySelector('meta[property="og:image:type"]')?.remove();
      }
    }
  }, [seo.title, seo.description, seo.image]);
  return null;
}
